/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GradeTypeOfPay {
    BASE = 'base',
    TARGET_TOTAL_CASH = 'targetTotalCash',
    TARGET_TOTAL_DIRECT = 'targetTotalDirect',
    LTI_ACTUAL = 'ltiActual',
    FIXED_COMP = 'fixedComp',
}
